export default __webpack_public_path__ + "i18n/translations/translation-ja.e61b7921.json";